import fetch ,{postFrom, getBlob} from "../utils/fetch";


export function kanbandetail(params) {
  return fetch({
    method:'POST',
    url:'/kanban/detail',
    data:params
  })
}

export function forRentRoom(params) {
  return fetch({
    method:'POST',
    url:'/kanban/forRentRoom',
    data:params
  })
}
